import OrderListPage from '@/pages/orders/page';

export default function TeamAllOrdersPage() {
  return <OrderListPage variant="team" />;
}
